export const DIALOG_CONST_PROGRAM_NOT_HELD_ON_2024 = "PROGRAM_NOT_HELD_ON_2024";
export type DIALOG_TYPE_PROGRAM_NOT_HELD_ON_2024 = typeof DIALOG_CONST_PROGRAM_NOT_HELD_ON_2024;
